// extracted by mini-css-extract-plugin
export var statItem = "_lb-1";
export var statsRow = "_lb-0";